export const ADD_BREAKDOWN_PATH = 'ADD_BREAKDOWN_PATH';
export const REMOVE_BREAKDOWN_PATH = 'REMOVE_BREAKDOWN_PATH';
export const CHANGE_BREAKDOWN_PATH = 'CHANGE_BREAKDOWN_PATH';
export const TOGGLE_BREAKDOWN_EXPANDED = 'TOGGLE_BREAKDOWN_EXPANDED';
export const COLLAPSE_BREAKDOWN_EXPANDED = 'COLLAPSE_BREAKDOWN_EXPANDED';
export const OPEN_MULTIPLE_ROWS = 'OPEN_MULTIPLE_ROWS';

// export const clearStateOfOpenRows = (state, index) =>
//   state.map((item, i) => (i > index ? { ...item, openRows: [] } : item));

export function clearBreakdownPathOfOpenRows(state) {
  return state?.map((item) => ({ ...item, openRows: [] }));
}

export function breakdownPathReducer(state = [], action) {
  switch (action.type) {
    case ADD_BREAKDOWN_PATH: {
      const { breakdownId } = action.payload;

      return [...state, { breakdownId, openRows: [] }];
    }

    case REMOVE_BREAKDOWN_PATH: {
      const { index } = action.payload;

      return [
        ...state.slice(0, index),
        ...clearBreakdownPathOfOpenRows(state.slice(index + 1)),
      ];
    }

    case CHANGE_BREAKDOWN_PATH:
      const { index, breakdownId } = action.payload;

      return [
        ...state.slice(0, index),
        { breakdownId, openRows: [] },
        ...clearBreakdownPathOfOpenRows(state.slice(index + 1)),
      ];

    case TOGGLE_BREAKDOWN_EXPANDED: {
      const { level, id } = action.payload;

      return state.map((breakdown, i) => {
        const { openRows } = breakdown;
        if (level === i) {
          return {
            ...breakdown,
            openRows: openRows.includes(id)
              ? openRows.filter((rowId) => rowId !== id)
              : [...openRows, id],
          };
        } else if (level < i) {
          return {
            ...breakdown,
            openRows: openRows.filter((rowId) => !rowId.includes(id)),
          };
        }

        return breakdown;
      });
    }

    case COLLAPSE_BREAKDOWN_EXPANDED: {
      return clearBreakdownPathOfOpenRows(state);
    }

    case OPEN_MULTIPLE_ROWS:
      const { level, ids } = action.payload;
      return state.map((breakdown, i) => {
        const { openRows } = breakdown;
        if (level === i) {
          return {
            ...breakdown,
            openRows: Array.from(new Set([...openRows, ...ids])),
          };
        }

        return breakdown;
      });

    default:
      return state;
  }
}
